import { useEffect } from "react";
import { Form, Input, Modal, Button } from "antd";

const FilterModal = ({ isFilterModalOpen, setIsFilterModalOpen, handleFilter, formRef }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (formRef) formRef.current = form;
  }, [form, formRef]);

  const onFinish = (values) => handleFilter(values);

  useEffect(() => {
    if (!isFilterModalOpen) {
      form.resetFields();
    }
  }, [isFilterModalOpen, form]);

  return (
    <Modal
      title="Filter Events Contacts"
      open={isFilterModalOpen}
      onCancel={() => setIsFilterModalOpen(false)}
      footer={null}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        className="Crm-modal-container"
      >
        <Form.Item name="name" label="Enter Name">
          <Input placeholder="Enter name" />
        </Form.Item>

        <Form.Item name="email" label="Enter Email">
          <Input placeholder="Enter email" />
        </Form.Item>

        <Form.Item name="phoneNumber" label="Enter Phone Number">
          <Input placeholder="Enter phone number" />
        </Form.Item>

        <Form.Item name="whatsappNumber" label="Enter WhatsApp Number">
          <Input placeholder="Enter whatsapp number" />
        </Form.Item>

        <Form.Item>
          <div className="form_submit pt-15" style={{ display: "flex", gap: "8px" }}>
            <Button className="back_button" onClick={() => setIsFilterModalOpen(false)}>
              Cancel
            </Button>
            <Button htmlType="submit" type="primary">
              Find
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default FilterModal;
